import React from 'react';
import { Stack, Typography } from '@mui/material';
import { DashboardResourceStyled, ResourceImageContainer, ResourceImage } from './dashboard-resource-item.styled';

export enum ObjectFitType {
  Cover = 'cover',
  Contain = 'contain',
}

type DashboardResourceItemProps = {
  title: string;
  subTitle: string;
  imagePath: string;
  onClick: () => void;
  objectFit?: ObjectFitType;
  fullWidth?: boolean;
  whiteImageBackground?: boolean;
};

export const DashboardResourceItem: React.FC<DashboardResourceItemProps> = ({
  title,
  subTitle,
  imagePath,
  objectFit = ObjectFitType.Cover,
  onClick,
  fullWidth,
  whiteImageBackground,
}) => (
  <DashboardResourceStyled onClick={onClick} {...(fullWidth && { sx: { width: '100%' } })}>
    <ResourceImageContainer sx={{ backgroundColor: whiteImageBackground ? 'white' : 'transparent' }}>
      <ResourceImage src={imagePath} alt={title} loading="lazy" sx={{ objectFit }} />
    </ResourceImageContainer>
    <Stack padding={2} alignItems="flex-start" flexGrow={1} alignSelf="stretch">
      <Typography sx={{ color: 'var(--color-type-secondary)', fontSize: '12px' }}>{subTitle}</Typography>
      <Typography sx={{ color: 'var(--color-type-secondary)', fontSize: '16px', fontWeight: 'bold' }}>
        {title}
      </Typography>
    </Stack>
  </DashboardResourceStyled>
);
